<template>
  <div class="pwc-info-preview">
    <van-nav-bar
      class="pwc-info-nav"
      title="详情"
      right-text="保存"
      left-arrow
      fixed
      @click-left="handleReturn"
    />
    <pwc-container>
      <van-cell-group>
        <van-field label="用户名" placeholder="请输入用户名" />
      </van-cell-group>
    </pwc-container>
  </div>
</template>

<script>
import RouterName from '@/constants/route'
import { NavBar, CellGroup, Field } from 'vant'
import PwcContainer from '@/views/layout/mobile/PwcContainer'

export default {
  components: {
    VanNavBar: NavBar,
    VanCellGroup: CellGroup,
    VanField: Field,
    PwcContainer
  },
  methods: {
    handleReturn() {
      this.$router.replace({
        name: RouterName.home,
        query: this.$route.query
      })
    },
    handleUpdate(name, value) {
      this.$router.replace({
        name: RouterName.update,
        query: {
          name: name,
          message: value,
          from: RouterName.preview
        }
      })
    }
  }
}
</script>

